import ErrorWithRetryView from '../../common/components/modal/ErrorWithRetryView';
import AssistantInformationContainer from '../containers/mx/AssistantInformationContainer';

export const MODAL_TYPE = {
    ERROR_WITH_RETRY_VIEW: 'ERROR_WITH_RETRY_VIEW',
    ASSISTANT_INFORMATION_VIEW: 'ASSISTANT_INFORMATION_VIEW'
};

export const MODAL_COMPONENTS = {
    ERROR_WITH_RETRY_VIEW: ErrorWithRetryView,
    ASSISTANT_INFORMATION_VIEW: AssistantInformationContainer
};
